import React from "react";
import { Field, useFormState } from "react-final-form";

import { NavigationButton } from "../components/NavigationButton";
import { FormData, FormResources } from "../types/formData";
import { Navigation } from "../types/navigation";
import { RadioButtonsContainer } from "../valuation-manager.styles";
import { useValuationManagerContext } from "../ValuationManagerContext";

interface QualificationsPageProps {
  setPageName: (pageName: Navigation) => void;
  formResources: FormResources;
}

export const QualificationsPage: React.FC<QualificationsPageProps> = ({
  setPageName,
  formResources,
}: QualificationsPageProps) => {
  const { appInput } = useValuationManagerContext();
  const { values }: { values: FormData } = useFormState();

  const allFieldsCompleted =
    values.log_book &&
    values.plate_transfer_pending &&
    values.key &&
    values.left_handed &&
    values.was_taxi &&
    values.speedo_change;

  return (
    <div>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          <RadioButtonsContainer>
            <legend className="col-sm-12 col-md-12 col-lg-12">
              {formResources.qualifications.title}
            </legend>
            {formResources.qualifications.fields.map((field) => (
              <div className="form-group" key={field.value}>
                <label>{field.label.replace("{{vrm}}", appInput?.vrm || "")}</label>
                <Field
                  name={field.value}
                  component="select"
                  required={true}
                  className="form-control"
                  data-testid={field.value}
                >
                  <option />
                  {field.options.map((option) => (
                    <option value={option.value} key={option.value}>
                      {option.label}
                    </option>
                  ))}
                </Field>
              </div>
            ))}
          </RadioButtonsContainer>
        </div>
      </div>
      <NavigationButton setPageName={setPageName} disabled={!allFieldsCompleted} />
    </div>
  );
};
